import { useMemo } from "react";
import {
  TabMenuItemTitle,
  TabMenuItem,
  TabMenuWrapper,
  TabMenuItemIcon,
  TabMenuContainer,
  TabMenuSlider,
} from "./styles";
import { useHistory } from "react-router-dom";
import { scheduleState } from "../../../../../recoil/schedule";
import { useSetRecoilState } from "recoil";
import { TabType } from ".";
import useSwipe from "../../../../../hooks/use-swipe";
import communityIcon from "../../../../../image-web/home/menu/게시판.svg";
import tournamentNewsIcon from "../../../../../image-web/home/menu/RFT.svg";
import searchIcon from "../../../../../image-web/home/menu/매장찾기.svg";
import rankingIcon from "../../../../../image-web/home/menu/랭킹.svg";
import reservationIcon from "../../../../../image-web/home/menu/매장예약.svg";
import eventIcon from "../../../../../image-web/home/menu/이벤트.svg";
import rutubeIcon from "../../../../../image-web/home/menu/홀덤유튜브.svg";
import calculatorIcon from "../../../../../image-web/home/menu/홀덤계산기.svg";
import marketIcon from "../../../../../image-web/home/menu/중고장터.svg";
import NewsIcon from "../../../../../image-web/home/menu/포커뉴스.svg";

interface TabMenuProps {
  tab: TabType;
  setTab: (tab: TabType) => void;
}

const TabMenu = ({ tab, setTab }: TabMenuProps) => {
  const history = useHistory();
  const setSchedule = useSetRecoilState(scheduleState);

  // 현재 활성 탭의 인덱스 계산
  const getActiveIndex = () => {
    switch (tab) {
      case TabType.PUB:
        return 0;
      case TabType.COMMUNITY:
        return 1;
      default:
        return 0;
    }
  };

  // 스와이프 핸들러
  const swipeHandlers = useSwipe({
    onSwipeLeft: () => {
      // 왼쪽으로 스와이프 시 다음 탭으로 이동
      if (tab === TabType.PUB) {
        setTab(TabType.COMMUNITY);
      }
    },
    onSwipeRight: () => {
      // 오른쪽으로 스와이프 시 이전 탭으로 이동
      if (tab === TabType.COMMUNITY) {
        setTab(TabType.PUB);
      }
    },
  });

  const menuHoldenItems = useMemo(
    () => [
      {
        icon: reservationIcon,
        title: "매장예약",
        onClick: () => history.push("/pub"),
        process: true,
      },
      {
        icon: searchIcon,
        title: "매장찾기",
        onClick: () => history.push("/search"),
        process: true,
      },
      {
        icon: tournamentNewsIcon,
        title: "RFT",
        onClick: () => {
          setSchedule(0);
          history.push("/rabbit");
        },
      },
      {
        icon: rankingIcon,
        title: "랭킹",
        onClick: () => history.push("/rank"),
        process: true,
      },
      {
        icon: eventIcon,
        title: "유튜버일정",
        onClick: () => history.push("/event-schedule"),
        process: true,
      },
    ],
    [history, setSchedule]
  );

  const menuCommunityItems = useMemo(
    () => [
      {
        icon: communityIcon,
        title: "게시판",
        onClick: () => history.push("/community/hand-board/all"),
        process: true,
      },
      {
        icon: NewsIcon,
        title: "포커뉴스",
        onClick: () => history.push("/news"),
        process: true,
      },
      {
        icon: rutubeIcon,
        title: "홀덤유튜브",
        onClick: () => history.push("/youtube"),
        process: true,
      },
      {
        icon: marketIcon,
        title: "중고장터",
        onClick: () => history.push("/community/market-board"),
        process: true,
      },
      {
        icon: calculatorIcon,
        title: "홀덤계산기",
        onClick: () => history.push("/calc"),
        process: true,
      },
    ],
    [history]
  );

  return (
    <TabMenuContainer {...swipeHandlers}>
      <TabMenuSlider activeIndex={getActiveIndex()}>
        {/* 홀덤펍 메뉴 */}
        <TabMenuWrapper>
          {menuHoldenItems.map((item, index) => (
            <TabMenuItem id={item.title} key={index} onClick={item.onClick}>
              <TabMenuItemIcon id={item.title} src={item.icon} alt="icon" />
              <TabMenuItemTitle id={item.title}>{item.title}</TabMenuItemTitle>
            </TabMenuItem>
          ))}
        </TabMenuWrapper>

        {/* 커뮤니티 메뉴 */}
        <TabMenuWrapper>
          {menuCommunityItems.map((item, index) => (
            <TabMenuItem id={item.title} key={index} onClick={item.onClick}>
              <TabMenuItemIcon id={item.title} src={item.icon} alt="icon" />
              <TabMenuItemTitle id={item.title}>{item.title}</TabMenuItemTitle>
            </TabMenuItem>
          ))}
        </TabMenuWrapper>
      </TabMenuSlider>
    </TabMenuContainer>
  );
};

export default TabMenu;
